import styled from 'styled-components'

// https://www.figma.com/design/dopjk2eU8rbtrQ3KbPmJGj/TC-Brand-Refresh-Working-File?node-id=3296-814&m=dev
const Small = styled.p`
  text-wrap: balance;
  font-size: 12px;
  @media (min-width: 768px) {
    font-size: 14px;
  }
`

export default Small
